export default __webpack_public_path__ + "static/media/Accounts.ac5cf3ab.jpg";